// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MITs
import { User } from '@lfx/core/models';

export interface SearchUserResult {
  searchUser: User[];
}
